import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/index'
import YinSi from '@/view/yinsi'
import DealerInfo from '@/view/dealerInfo'
import Slider from '@/components/Slider'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/dealer-inq',
      name: 'Index',
      component: Index,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/yinsi',
      name: 'YinSi',
      component: YinSi
    },
    {
      path: '/dealerInfo',
      name: 'DealerInfo',
      component: DealerInfo
    },
    {
      path: '/slider',
      name: 'Slider',
      component: Slider
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js